import React from 'react';

import Loader from './Loader';

/**
 * check if all Required data sets (as defined by the set up)
 * are available via props or if one of them has an error
 * @param  {object} setup
 * @param  {object} props
 * @return {object}       isLoading or error or all data sets
 */
function extractState(setup, props) {
    const keys = Object.keys(setup);
    const childProps = {};
    let item;

    for (let i = 0; i < keys.length; i += 1) {
        item = props[keys[i]];

        if (!item) {
            return {
                isLoading: true
            };
        } // else
        if (item.error) {
            return {
                error: item.error
            };
        } // else
        if (!item.data) {
            return {
                error: 'no data'
            };
        }
        childProps[keys[i]] = item.data;
    }
    return { data: childProps };
}

/**
 * in case of an error, how to display it
 * @param  {function|node} errorHandling function or something that can get rendered by react
 * @param  {object|string} error
 * @return {node}
 */
function genErrorText(errorHandling, error) {
    if (typeof errorHandling === 'function') {
        return errorHandling(error);
    }
    if (errorHandling) {
        return errorHandling;
    }
    return 'Es ist ein Fehler aufgetreten';
}
/**
 * on top of the Loader this component handles the loading and the error state for you
 * @param  {node} Component                 component to render with the loaded Data
 * @param  {object} setup                   config what to download, check Loader.loadMultipleFiles for full description of it structure
 * @param  {function|string} errorHandling  optional way to improve the error text, via a function or an fix text
 * @return {class}                a class to use in the parents render Method
 */
export default (Component, setup, errorHandling) => {
    return Loader(
        (props) => {
            const state = extractState(setup || props.loaderConfig, props);
            if (state.isLoading) {
                return (
                    <div key="loading" className="loading">
                        ...loading
                    </div>
                );
            } // else

            if (state.error) {
                return (
                    <div key="error" className="error">
                        { genErrorText(errorHandling, state.error)}
                    </div>);
            } // else

            return (
                <div key="result" className="result">
                    <Component
                        {...props}
                        {
                        // the order is important as data has to override some of the props
                        // the props include error or data, but the child shall get only the pure file content
                            ...state.data
                        }
                    />
                </div>
            );
        },
        setup
    );
};
